module.exports = __webpack_public_path__ + "media/audio16.5adcf74b.mp3";